import { DevicePage, DevicesPage, FleetPage } from '@lifepowr/components/src/modules';
import { Footer, Header, NavBar } from '@lifepowr/components/src/components-core';
import { Fleets } from '@lifepowr/components/src/components';

import { PolicyAuth } from '@lifepowr/components/src/components/PolicyAuth';

import { legacy } from '@lifepowr/components';

const { Bones } = legacy;

function Navigation(_props) {
  return <NavBar />;
}

const base = {
  Header,
  Navigation,
  Footer,
};

const baseFleets = {
  Header,
  Footer,
};

const routes = {
  '/': {
    components: {
      ...baseFleets,
      Content: Fleets,
    },
    exact: true,
  },
  '/:fleetOption': {
    components: {
      ...base,
      Content: FleetPage,
    },
    exact: true,
  },
  '/:fleetOption/devices': {
    components: {
      ...base,
      Content: DevicesPage,
    },
    exact: true,
  },
  '/:fleetOption/devices/:deviceName/:pathName': {
    components: {
      ...base,
      Content: DevicePage,
    },
  },
};

const redirects = [
  {
    from: '/:fleetOption/devices/:deviceName',
    to: ':deviceName/general-status',
    exact: true,
  },
];

export function LandingPage() {
  return (
    <PolicyAuth>
      <Bones
        routes={routes}
        redirects={redirects}
      />
    </PolicyAuth>
  );
}
